import { Spinner as ChakraSpinner, SpinnerProps } from "@chakra-ui/react"

const Spinner = (props: SpinnerProps) => {
  return (
    <ChakraSpinner
      thickness="2px"
      speed="0.8s"
      emptyColor="gray.200"
      color="gray.400"
      size="lg"
      {...props}
    />
  )
}

export default Spinner
